<div class="widget">
  <ngx-simplebar [options]="{ autoHide: false }" id="sideBar">
    <div class="sideBarContent">
      <div class="sideBarMain">
        <img src="assets/images/logo.png" id="logo" alt="BOTEVO Logo" />
        <div class="menuItems">
          @for (menuItem of menuItems; track menuItem; let i = $index) {
            <div
              class="menuRow"
              [ngClass]="{
                selectedMenuItem: !menuItem.children && i === selectedIndex,
              }"
              (click)="menuItemClicked(i)"
            >
              <div class="iconContainer">
                @if (menuItem.icon === "energy_tool") {
                  <img class="menuIcon" src="assets/icons/energy_tool.png" alt="Energy Tool" />
                } @else {
                  <app-svg-icon [iconName]="menuItem.icon" iconSize="sm" iconColor="primary"></app-svg-icon>
                }

                @if (menuItem.notifications && notificationCount()) {
                  @if (notificationCount() > 0 && notificationCount() < 100) {
                    <span class="notificationBadge">{{ notificationCount() }}</span>
                  } @else if (notificationCount() > 99) {
                    <span class="notificationBadge">99+</span>
                  }
                }
              </div>
              <span class="menuText overflowDot">
                {{ menuItem.name | translate }}
              </span>
              @if (menuItem.children && menuItem.children.length > 0) {
                @if (menuItem.showChildren) {
                  <app-svg-icon
                    class="dropdownIcon"
                    iconName="arrow_down"
                    iconSize="xs"
                    iconColor="primary"
                  ></app-svg-icon>
                } @else {
                  <app-svg-icon
                    class="dropdownIcon"
                    iconName="arrow_down"
                    iconSize="xs"
                    iconColor="secondary"
                  ></app-svg-icon>
                }
              }
            </div>
            @if (menuItem.showChildren && menuItem.children && menuItem.children.length > 0) {
              @for (subMenuItem of menuItem.children; track subMenuItem; let childI = $index) {
                <div
                  class="subMenuRow"
                  [ngClass]="{
                    selectedChildItem: i === selectedIndex && childI === selectedIndexChildren,
                  }"
                  (click)="navigateTo(subMenuItem.path)"
                >
                  <span class="submenuLine"></span>
                  <span class="subMenuText overflowDot">{{ subMenuItem.name | translate }}</span>
                </div>
              }
            }
          }
        </div>
      </div>
    </div>
  </ngx-simplebar>

  <div class="bottomInfo">
    <button
      type="button"
      class="menuRow profileSettingsTrigger"
      [attr.aria-label]="('side_bar.user_settings' | translate) + (userDisplayName() ? ': ' + userDisplayName() : '')"
      aria-haspopup="dialog"
      aria-controls="profileMenuPopover"
      [attr.aria-expanded]="profileMenu.overlayVisible"
      (click)="profileMenu.toggle($event)"
    >
      <div class="iconContainer">
        <app-svg-icon iconName="profile-circle" iconColor="gray"></app-svg-icon>
      </div>
      <span class="profileSettingsDetails">
        <span class="profileSettingsName overflowDot">
          @if (userDisplayName()) {
            {{ userDisplayName() }}
          } @else {
            {{ "side_bar.user_settings" | translate }}
          }
        </span>
        @if (authenticatedUser()?.email; as email) {
          <span class="profileSettingsEmail overflowDot">{{ email }}</span>
        }
      </span>
    </button>

    <div class="sideBarFooter">
      <a class="sideBarFooterLink" [href]="getLink('imprint')" target="_blank" rel="noopener noreferrer">
        {{ "side_bar.imprint" | translate }}
      </a>
      <a class="sideBarFooterLink" [href]="getLink('data_privacy')" target="_blank" rel="noopener noreferrer">
        {{ "side_bar.data_privacy" | translate }}
      </a>

      <button
        *appHasPermission="{
          permissions: [permissions.allPermissions.ASSET_MASTER_DATA_CREATE],
        }"
        type="button"
        class="versionHint versionHintLink"
        (click)="navigateTo('versionInfo')"
      >
        {{ "common.version" | translate }}: {{ versionNumber }}
      </button>
      <span
        *appHasPermission="{
          permissions: [permissions.allPermissions.ASSET_DYNAMIC_DATA_READ],
          missingPermission: permissions.allPermissions.ASSET_MASTER_DATA_CREATE,
        }"
        class="versionHint"
      >
        {{ "common.version" | translate }}: {{ versionNumber }}
      </span>
    </div>

    <p-popover
      #profileMenu
      [ariaLabel]="'side_bar.user_settings' | translate"
      [pt]="{ root: { id: 'profileMenuPopover' } }"
      styleClass="profileMenuPopover"
    >
      <div class="profileMenu">
        <button type="button" class="profileMenuItem" (click)="openProfileSettings(); profileMenu.hide()">
          {{ "side_bar.settings" | translate }}
        </button>

        <span class="profileMenuSeparator"></span>

        <button type="button" class="profileMenuItem profileMenuLogout" (click)="logout()">
          <app-svg-icon iconName="logout" iconSize="sm" iconColor="gray"></app-svg-icon>
          {{ "side_bar.logout" | translate }}
        </button>
      </div>
    </p-popover>
  </div>
</div>
